<template>
  <div
    id="ai-agents"
    class="floor2"
    :style="{
      backgroundImage: `url(${industryList[industrySelecedIndex].bg})`,
    }"
  >
    <div data-aos="fade-up">
      <div>
        <div
          style="
            font-weight: bold;
            font-size: 32px;
            color: #222222;
            padding-top: 80px;
            margin-bottom: 14px;
          "
        >
          企业级智能体平台
        </div>
        <div style="font-size: 16px; color: #595859; line-height: 21px">
          构建你的专属AI生产力，多智能体协作释放企业潜能
        </div>
      </div>
      <div class="industry-container">
        <div class="industry-left">
          <div
            v-for="(item, index) in industryList"
            :key="index"
            :class="
              industrySelecedIndex == index
                ? 'industry-menu-item-sel'
                : 'industry-menu-item'
            "
            @mouseenter="handleMouseEnter(index)"
            @mouseleave="handleMouseLeave(index)"
          >
            <div
              v-if="industrySelecedIndex == index"
              class="industry-menu-item-blue"
            />
            <img
              class="industry-menu-item-img"
              v-if="industrySelecedIndex == index"
              :src="item.imgSrcSel"
              alt=""
            />
            <img
              class="industry-menu-item-img"
              v-else
              :src="item.imgSrc"
              alt=""
            />
            <div
              :class="
                industrySelecedIndex == index
                  ? 'industry-menu-item-title-sel'
                  : 'industry-menu-item-title'
              "
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="industry-right">
          <div
            class="f2-right-container"
            ref="f2-right-container"
            :class="{ 'slide-in': shouldAnimate }"
          >
            <div style="font-size: 28px; color: #222222; text-align: left">
              {{ industryList[industrySelecedIndex].title }}
            </div>
            <div
              style="
                font-size: 16px;
                color: #595859;
                text-align: left;
                margin-top: 30px;
              "
            >
              {{ industryList[industrySelecedIndex].desc }}
            </div>
            <img
              style="margin-top: 30px; width: 820px; height: 100px"
              :src="industryList[industrySelecedIndex].iconlist"
              alt=""
            />
            <div
              class="blue-btn"
              @click="linkPageFn(industryList[industrySelecedIndex].path)"
            >
              了解更多
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shouldAnimate: false,
      animatingElement: null,
      industrySelecedIndex: 0,
      industryList: [
        {
          title: "千橙万象（AI生图）",
          imgSrc: require("@/assets/home/industry/id-menu-1.svg"),
          imgSrcSel: require("@/assets/home/industry/id-menu-sel-1.svg"),
          desc: "基于大语言模型与多模态生成技术，为企业提供文案、海报、短视频脚本、营销物料等一站式智能创作能力。系统可快速学习并精准适配品牌调性与场景需求，支持批量高效产出，大幅缩短内容生产周期，释放创意生产力。同时，内置智能素材库与合规性校验功能，确保内容质量与安全，让企业内容营销更高效、更省心。",
          iconlist: require("@/assets/home/industry/iconlist-1.png"),
          bg: require("@/assets/home/industry/bg1.jpg"),
          path: "https://ai.qcos.cn/qcwxai/",
        },
        {
          title: "AI外呼",
          imgSrc: require("@/assets/home/industry/id-menu-2.svg"),
          imgSrcSel: require("@/assets/home/industry/id-menu-sel-2.svg"),
          desc: "依托先进的智能语音交互与自然语言处理技术，构建覆盖售前咨询、售后支持、营销外呼等全场景的智能客服体系。通过 7×24小时自动应答、智能分流与精准话术匹配，大幅降低企业人力成本，提升客户服务的响应效率与沟通满意度。同时，系统可无缝对接企业现有业务系统，实现服务流程全闭环管理与数据化质量监控，助力企业完成客户服务的全面转型。",
          iconlist: require("@/assets/home/industry/iconlist-2.png"),
          bg: require("@/assets/home/industry/bg2.jpg"),
          path: "https://smart.htd.cn/user-center/#/login?clientId=voice_outbound_call",
        },
        {
          title: "行业分析",
          imgSrc: require("@/assets/home/industry/id-menu-3.svg"),
          imgSrcSel: require("@/assets/home/industry/id-menu-sel-3.svg"),
          desc: "整合全网公开数据、权威行业报告与用户行为信息，通过智能 AI 算法深度挖掘用户偏好、竞品动态与行业趋势。系统自动输出多维度可视化分析报告，帮助企业精准把握市场脉搏，为市场策略制定、产品迭代优化、营销活动策划提供专业、数据驱动的精准支撑。平台支持自定义市场预警与关键信息推送，让企业及时捕捉市场变化，做出更科学的商业决策。",
          iconlist: require("@/assets/home/industry/iconlist-3.png"),
          bg: require("@/assets/home/industry/bg3.jpg"),
          path: "https://ai.qcos.cn/qcwxai/",
        },
        // {
        //   title: "社交电商",
        //   imgSrc: require("@/assets/home/industry/id-menu-4.svg"),
        //   imgSrcSel: require("@/assets/home/industry/id-menu-sel-4.svg"),
        //   desc: "互联网+时代，社交电商得到新的发展，深挖“人”的价值，扩充私域流量，实现规模化增长。借助主流社交平台微信、微博、小红书等通过拼团购、达人分享、KOL意见领袖等多种方式实现社交裂变增长。社交电商构建了一套完整的运营体系，帮助品牌和商家深度挖掘社交网络的价值，以社群分享、社区团购、销售分佣、购物返利等方式，实现低成本、高效率的获客、转化与裂变。",
        //   iconlist: require("@/assets/home/industry/iconlist-4.png"),
        //   bg: require("@/assets/home/industry/bg4.jpg"),
        //   path: "shopping",
        // },
        // {
        //   title: "私域直播",
        //   imgSrc: require("@/assets/home/industry/id-menu-6.svg"),
        //   imgSrcSel: require("@/assets/home/industry/id-menu-sel-6.svg"),
        //   desc: "基于视频互动技术及直播服务体系，针对不同业务和使用场景，提供全场景直播解决方案和服务。私域直播具备简单、轻量、高效的特点，可以精准触达、反复激活使品牌最大程度贴近用户，占据用户心智、增强粘性，根据用户的需求和兴趣进行定制化内容展示和互动。",
        //   iconlist: require("@/assets/home/industry/iconlist-5.png"),
        //   bg: require("@/assets/home/industry/bg5.jpg"),
        //   path: "live",
        // },
      ],
    };
  },

  methods: {
    linkPageFn(pageName) {
      // const params = this.$router.resolve({
      //   name: pageName,
      // });
      window.open(pageName, "_blank");
    },
    // 当鼠标进入元素时触发
    handleMouseEnter(index) {
      console.log("鼠标进入了元素" + index);
      this.industrySelecedIndex = index;
      this.shouldAnimate = true;
      this.$nextTick(() => {
        this.animatingElement = this.$refs["f2-right-container"]; // 假设动画应用于根元素

        // 可选：使用setTimeout模拟动画结束（不推荐）
        // setTimeout(() => {
        //   this.resetAnimationState();
        // }, 500); // 假设动画持续时间为500ms

        // 更好的做法：使用animationend事件监听器
        if (this.animatingElement) {
          this.animatingElement.addEventListener(
            "animationend",
            this.resetAnimationState
          );
        }
      });
    },
    resetAnimationState() {
      // 动画完成后重置状态
      this.shouldAnimate = false;

      // 如果需要，可以在这里移除事件监听器以避免内存泄漏
      // 但在这个例子中，我们假设这个组件的生命周期与动画监听器的生命周期一致
      // 如果不是这样，你应该在组件销毁时移除监听器
    },
    // 当鼠标离开元素时触发
    handleMouseLeave(index) {
      // console.log('鼠标离开了元素');
    },
  },
  beforeDestroy() {
    if (this.animatingElement) {
      this.animatingElement.removeEventListener(
        "animationend",
        this.resetAnimationState
      );
    }
  },
};
</script>

<style lang="less" scoped>
.floor2 {
  width: 100%;
  height: 740px;
  transition: all .5s;

  .industry-container {
    width: 1200px;
    height: 470px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(10, 30, 69, 0.08);
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    flex-direction: row;

    .industry-left {
      width: 241px;
      height: 470px;
      background: #f3f4fb;
      border-radius: 10px 0px 0px 10px;
      border: 1px solid #ffffff;
      padding-top: 20px;

      .industry-menu-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 60px;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .industry-menu-item-sel {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 60px;
        margin-top: 10px;
        margin-bottom: 10px;
        background: #d9e5fd;
      }

      .industry-menu-item-blue {
        width: 4px;
        height: 20px;
        background: #1763ff;
      }

      .industry-menu-item-title {
        font-size: 16px;
        color: #222222;
        line-height: 22px;
      }

      .industry-menu-item-title-sel {
        font-size: 16px;
        color: #1763ff;
        line-height: 22px;
      }

      .industry-menu-item-img {
        width: 24px;
        height: 24px;
        margin-left: 34px;
        margin-right: 15px;
      }
    }

    .industry-right {
      width: 960px;

      .f2-right-container {
        margin-left: 40px;
        margin-top: 47px;
        margin-right: 50px;
        display: flex;
        flex-direction: column;
      }

      .blue-btn {
        margin-top: 35px;
        width: 144px;
        height: 48px;
        background: #1763ff;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        color: #ffffff;
        line-height: 48px;
        text-align: center;
        &:hover {
          background: #2E72FF;
        }
      }
    }
  }
}

@keyframes slideIn {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 应用动画的类 */
.slide-in {
  animation: slideIn 0.5s ease-out forwards;
}
</style>
